/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompletePathwayDto } from '../../models/complete-pathway-dto';
import { InitializePathwayDto } from '../../models/initialize-pathway-dto';

export interface PathwaysControllerInitialize$Params {
  
    /**
     * The pathway initialization data with all user information
     */
    body: InitializePathwayDto
}

export function pathwaysControllerInitialize(http: HttpClient, rootUrl: string, params: PathwaysControllerInitialize$Params, context?: HttpContext): Observable<StrictHttpResponse<CompletePathwayDto>> {
  const rb = new RequestBuilder(rootUrl, pathwaysControllerInitialize.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompletePathwayDto>;
    })
  );
}

pathwaysControllerInitialize.PATH = '/thalea-pathways/pathways/initialize';
